import $ from "jquery";
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import init from '../AccessControl/Check';


import DatePickerV2 from "../../../components/Date/DatePicker-v2";
import DatePickerRange from "../../../components/Date/DatePickerRange";
import moment from "moment";
import PostLoginGetApi from "../../../components/Api/PostLoginGetApi";
import { CSVLink } from "react-csv";
import number_format from "../../../components/Constants/NumberFormat"; 
import Popup from "../../../components/Popup";
import { ReactComponent as CloseBtn } from './../../../assets/icons/close.svg';
import UserBasicInfoQRContext from "../../../components/Context/UserBasicInfoQRContext";
import PostLoginPostApi from "../../../components/Api/PostLoginPostApi";
import { toast } from "react-toastify";


const SettlementProcess = () => {

    const pageName = "Settlement Process";
    const isAccess = init(pageName);

    const companyProfile = useContext(UserBasicInfoQRContext);


    var setDatePicker = () => {
        $("#date-div").hide();
        $("#date-range-div").hide();
    
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
    
    
        var v = $("#date-range-data").val();
        if (v === "custom") {
            $("#date-range-div").show();
        }
        else if (v === "all") {
            $("#date-div").attr("style", "display:flex");
        }
    }

    const [orderList, setOrderList] = useState([]);
    const [isFilter, setIsFilter] = useState(false);
    const [reqParam, setReqParam] = useState({
        page: 1
    })


    const filterClick = () => {
        $("#filter-toggle-icon").toggleClass("rotate-180");
        $(".custom-btn.filter").toggleClass("active");

        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const [refreshCounter, setRefreshCounter] = useState(0);
    useEffect(() => {
        PostLoginGetApi("settlement/ready-for-process", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setOrderList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })

    }, [isFilter, reqParam, refreshCounter]);



    const filter = () => {
        
        reqParam.page = 1;
        
        reqParam.service_type = $("#service_type").val() ?? "";
        reqParam.code = $("#search-by-transaction-id").val() ?? "";

        // Date Filter
        let from = "", end = "";
        if ($("#date-range-data").val() === "custom") {
            from = $("#fromDate").val();
            end = $("#toDate").val();

            if (from.length === 0 || end.length === 0) {
                from = "";
                end = "";
            }
            else {
                let nextDate = new Date(end);
                nextDate.setDate(nextDate.getDate());
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");
                end = nextDate;
            }
        }
        else if ($("#date-range-data").val() === "all") {
            const singleDatePicker = $("#singleDatePicker").val();
            if (singleDatePicker.length !== 0) {
                let nextDate = new Date(singleDatePicker);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");

                from = singleDatePicker;
                end = nextDate;
            }
        }


        reqParam.from = from;
        reqParam.end = end;

        setReqParam({ ...reqParam });
        setIsFilter(true);
    }



    const resetFilterData = () => {

        $("#date-range-data").val("custom");
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
        $("#to-date-picker").val("");


        $("#service_type").val('all')
        $("#search-by-transaction-id").val("");


        $("#date-div").hide();
        $("#date-range-div").show();


        filter();
        setIsFilter(false);
    }


    const checkBoxEnable = (id) => {
        let status = $("#cb_order_" + id).prop("checked");
        if( status ) {
            $("#cb_order_" + id).prop("checked", false);
            checkStatusTopProcessButton();
            return;
        }

        $("#cb_order_" + id).prop("checked", true);
        checkStatusTopProcessButton();
    }


    const selectAllCheckBox = () => {
        if( $("#all_cb_select").prop("checked") ) {
            $(".order_cb").prop("checked", true);
            checkStatusTopProcessButton();
            return;
        }
        
        $(".order_cb").prop("checked", false);
        checkStatusTopProcessButton();
    }


    const checkBoxEnable2 = (id) => {
        setTimeout(()=> {
            let status = $("#cb_order_" + id).prop("checked");
            if( status ) {
                $("#cb_order_" + id).prop("checked", false);
                checkStatusTopProcessButton();
                return;
            }

            $("#cb_order_" + id).prop("checked", true);
            checkStatusTopProcessButton();
        }, 100);
    }


    const checkStatusTopProcessButton = () => {
        setTimeout(()=>{ 
            let ck_box = $('input[type="checkbox"][name="order_cb"]:checked').length;
            if( ck_box > 0) {
                $("#top_process_btn").html(`Process ${ck_box} selected order`);
                $("#top_process_btn").show();
                $(".process_button_single").attr("disabled",true);
                return;
            }
            
            $(".process_button_single").attr("disabled",false);
            $("#top_process_btn").hide();
            $("#top_process_btn").html(`Process`);
        }, 300);
    }

    const [processData, setProcessData] = useState({
        id: [],
        type: [],
        count: 0,
        order_amount: 0,
        settlement_fee: 0,
        settled_amount: 0,
        trade_price: 0,
        settlement_on: companyProfile?.settlement_type,
        data: [],
        remarks: ""
    });

    
    const [showProcessDialog, setShowProcessDialog] = useState(false);
    const processDialog = () => {
        let cb = $('input[type="checkbox"][name="order_cb"]');
        let c = 0;
        
        let dataArr = [];
        let ids = [];
        let types = [];
        var total = 0;
        var fee = 0;
        var payable = 0;
        var tradePrice = 0;

        cb.each((i)=>{
            if( cb.eq(i).prop("checked") ) {

                ids.push($(".order_id").eq(i).val());
                types.push($(".order_type").eq(i).val());
                tradePrice += parseFloat($(".order_trade_price").eq(i).val() ?? 0);
                total += parseFloat($(".order_amount").eq(i).val() ?? 0);
                fee += parseFloat($(".order_fee").eq(i).val() ?? 0);
                payable += parseFloat($(".order_payable").eq(i).val() ?? 0);

                dataArr.push([
                    parseInt($(".order_id").eq(i).val()), 
                    $(".order_transaction_no").eq(i).val(), 
                    $(".order_type").eq(i).val(), 
                    parseFloat($(".order_amount").eq(i).val() ?? 0),
                    parseFloat($(".order_fee").eq(i).val() ?? 0),
                    parseFloat($(".order_payable").eq(i).val() ?? 0),
                    $(".order_quantity").eq(i).val(),
                    parseFloat($(".order_trade_price").eq(i).val() ?? 0)
                ]);

                c++;
            }
        });

        setProcessData({...processData, id: ids, type: types, count: c, order_amount: total, settlement_fee: fee, settled_amount: payable, trade_price: tradePrice, data: dataArr});
        setShowProcessDialog(true);
    }

    const processDialogSingle = (id, total, fee, payable, type, bookingCode, quantity, tradePrice) => {
        if( tradePrice <= 0 || isNaN(tradePrice) === true ) {
            tradePrice = total;
        }
        let dataArr = [];
        dataArr.push([id, bookingCode, type, total, fee, payable, quantity, tradePrice]);

        setProcessData({...processData, count: 1, id: [id], type: [type], order_amount: total, settlement_fee: fee, settled_amount: payable, trade_price: tradePrice, data: dataArr});
        setShowProcessDialog(true);
    }

    const closeProcessBox = () => {
        $('input[type="checkbox"][name="order_cb"]').prop("checked",false);
        $('#all_cb_select').prop("checked",false);
        setProcessData({
            id: [],
            type: [],
            count: 0,
            order_amount: 0,
            settlement_fee: 0,
            settled_amount: 0,
            trade_price: 0,
            data: []
        });

        setShowProcessDialog(false);
        checkStatusTopProcessButton();
    }


    const processConfirm = async () => {
        try {
            await PostLoginPostApi("settlement/confirm-process", JSON.stringify(processData)).then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);
    
                if(response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);
    
                    if (responseData["code"] === 200) {
                        toast.success(responseData["messages"].toString());
                        sendEmail(processData);
                        closeProcessBox();
                        excelDownload();

                        setRefreshCounter((prev)=>prev+1);
                        return;
                    }

                    toast.error(responseData["messages"].toString());
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        catch(ex) {
            toast.error("A problem occur. Please try again.");
            console.log(ex);
        }
    }

    const sendEmail = async (__processData) => {
        try {
            let reqData = {};
            reqData["email"] = process.env.REACT_APP_ADMIN_EMAIL;
            reqData["ref_no"] = __processData?.settlement_on ?? "NA";
            reqData["name"] = companyProfile?.name;
            reqData["date"] = moment(__processData?.settlement_date).format('DD MMM, YYYY');
            reqData["acc_from"] = "NA";
            reqData["acc_to"] = "NA";
            reqData["remarks"] = __processData?.remarks ?? "";
            reqData["no_of_orders"] = __processData?.count ?? 0;
            reqData["charge_amount"] = __processData?.settlement_fee ?? 0;
            reqData["total_amount"] = __processData?.order_amount ?? 0;
            reqData["payable"] = __processData?.settled_amount ?? 0;


            await PostLoginPostApi("settlement/confirmation-email", JSON.stringify(reqData)).then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);
    
                if(response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);
    
                    if (responseData["code"] === 200) {
                        console.log("Email send successfully.");
                        return;
                    }
                    
                    console.log(responseData["messages"].toString() ?? "");
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        catch(ex) {
            toast.error("A problem occur. Please try again.");
            console.log(ex);
        }
        
            
        return false;
    }


    const excelDownload = () => {
        try {

            let i = 0;
            let arr = [];
    
            arr[i++] = ["#","Debit Account No (Transferred From)",  "Email /Voucher No (Empty)", "Batch No", "Beneficiary Name (Partner Bank A/C Name)", "Credit Account  (Partner Bank A/C Number)", "Txn Type", "Bank Name (Partner Bank Name)", "Bank Branch Name (Partner Bank Branch)", "Routing No  (Partner Bank Routing Number)", "Order Id", "Order Amount", "Settlement Fee", "Net Price", "Trade Price", "Settlement Type", "Remarks", "\r\n"];
            
    
            processData?.data?.map((val, index)=> 
                arr[i++] = [++index,"",  "", "", companyProfile?.bank_account_name, companyProfile?.bank_account_number + "'", "", 
                companyProfile?.bank_name, companyProfile?.bank_branch_name, companyProfile?.bank_routing, val[1], val[3], val[4], val[5], val[7], processData?.settlement_on ?? "net_price", processData?.remarks ?? "", "\r\n"]
            );
            
    
            // Prepare CSV and Download
            var blob = new Blob(arr, {type: "octet/stream"});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            
            link.href = url;
            link.setAttribute(
                'download',
                `settlement-process-list_${moment().format("DD-MM-YYYY")}.csv`,
            );
            
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        catch(ex) {
            toast.error("A problem occur while downloading the excel file.");
            console.log(ex);
        }
    }


    const changeSettledAmountOption = (e) => { 
        $("#settled_amount_display_trade_price").hide();
        $("#settled_amount_display_net_price").hide();
        let v = e.target.value;
        if( v === "trade_price" ) {
            $("#settled_amount_display_trade_price").show();
            setProcessData({...processData, settlement_on: "trade_price"});
            return;
        }

        setProcessData({...processData, settlement_on: "net_price"});
        $("#settled_amount_display_net_price").show();
    }


    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }
    

    
    return (
        <div className="custom-container w-full font-montserrat flex">

            {/** Left Side */}
            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-2 pt-0">
                    <div className="w-1/2 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5 mb-5">Here’s your unsettled order lists at a glance</h6>
                        {/* <h6 className='text-lg font-medium mb-5'>Today</h6> */}
                    </div>



                    <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">

                        <button type="button" onClick={processDialog} id="top_process_btn" className="mr-3 text-md border-[#00D632] border-2 rounded hover:bg-[#00D632] hover:text-white hidden" style={{padding: "9px 20px"}}>
                            Process
                        </button>

                        
                        <CSVLink className="custom-btn mr-2 text-center" filename={"unsettlement-order-history-report.csv"} data={orderList}>
                            Export CSV
                        </CSVLink>

                        <Link to="#" onClick={filterClick} className="custom-btn filter text-center w-[92px]">Filter</Link>
                        <svg id="filter-toggle-icon" className='static -ml-4' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="#1A202C" />
                            <path d="M17 19L13 15L17 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
                        </svg>
                    </div>
                </div>


                <div className="w-full flex overflow-hidden text-left pt-2">
                
                    {/* <div className="box hover-black-green w-1/4 py-5 h-auto bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Unsettled Order
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary.total ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Order Amount
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.order_amount ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%]  bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Amount After Settlement
                        </Link>

                        <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.total_settled_amount ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Fee
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.fee_amount ?? 0}</h3>
                    </div> */}



                </div>


                {/* DATA TABLE */}
                <div className="flex flex-col w-full">
                    <div className='-m-1.5 overflow-x-auto pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className="border rounded-lg shadow overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="px-4 py-3 text-center">
                                                <input type="checkbox" id="all_cb_select" onClick={selectAllCheckBox} />
                                            </th>
                                            <th scope="col" className="px-6 py-3">Order <br/>Date & Time</th>
                                            <th scope="col" className="px-6 py-3">Order <br/>Transaction ID</th>
                                            <th scope="col" className="px-3 py-3 text-center">Quantity</th>
                                            <th scope="col" className="px-4 py-3 text-center">Order <br/>Amount (A)</th>
                                            <th scope="col" className="px-4 py-3 text-center">Settlement <br/>Fee (B)</th>
                                            <th scope="col" className="px-4 py-3 text-center">Net <br/>Price (A-B)</th>
                                            <th scope="col" className="px-4 py-3 text-center">Trade <br/>Price</th>
                                            <th scope="col" className="px-4 py-3 text-center">Service</th>
                                            <th scope="col" className="px-4 py-3 text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200'>

                                        {orderList.map((val, index)=> (
                                            (val !== null) &&

                                            <tr key={index}>
                                                <td className='py-2 text-center border-r-2 font-semibold cursor-pointer' onClick={()=>checkBoxEnable(index)}>
                                                    <input className="order_cb" name="order_cb" type="checkbox" id={`cb_order_${index}`} 
                                                    onClick={()=>checkBoxEnable2(index)} readOnly={true} value={index} />

                                                    <input type="hidden" value={val.id} name="order_id" className="order_id" />
                                                    <input type="hidden" value={val.booking_code} name="order_transaction_no" className="order_transaction_no" />
                                                    <input type="hidden" value={val.quantity} name="order_quantity" className="order_quantity" />

                                                    {(val.trade_price <= 0 || val.trade_price === "-") ? 
                                                        <input type="hidden" value={val.total_price} name="order_trade_price" className="order_trade_price" />
                                                        :
                                                        <input type="hidden" value={val.trade_price} name="order_trade_price" className="order_trade_price" />
                                                    }
                                                    <input type="hidden" value={val.total_price} name="order_amount" className="order_amount" />
                                                    <input type="hidden" value={val.settlement_amount} name="order_fee" className="order_fee" />
                                                    <input type="hidden" value={val.settled_amount} name="order_payable" className="order_payable" />
                                                    <input type="hidden" value={val.service_type} name="order_type" className="order_type" />

                                                </td>
                                                <td className='px-6 py-2 border-r-2'>
                                                    {moment(val.dt).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='px-6 py-2 border-r-2 text-[#0774E9]'>
                                                    {(val.service_type === "Shop") ? 
                                                        <Link to={`/dashboard/orders/order-invoice/${val.id}?source=settlement`} target={"_blank"} className='cursor-pointer'>{val.booking_code ?? ""}</Link>
                                                    :
                                                        <span>{val.booking_code ?? ""}</span>
                                                    }
                                                </td>
                                                <td className='px-3 py-2 border-r-2 text-center'>{val.quantity}</td>
                                                <td className='px-4 py-2 border-r-2 text-center'>{number_format(val.total_price,2) ?? 0}</td>
                                                <td className='px-4 py-2 border-r-2 text-center'>{number_format(val.settlement_amount ?? 0,2)}</td>
                                                <td className='px-4 py-2 border-r-2 text-center'>{number_format(val.settled_amount ?? 0, 2)}</td>
                                                <td className='px-4 py-2 border-r-2 text-center'>{(val.trade_price > 0) ? number_format(val.trade_price, 2) : "-"}</td>
                                                <td className='px-4 py-2 border-r-2 text-center'>{val.service_type}</td>
                                                <td className='px-3 py-2 text-center'>
                                                    <button type="button" onClick={()=>processDialogSingle(val.id, val.total_price, val.settlement_amount, val.settled_amount, val.service_type, val.booking_code, val.quantity, val.trade_price)} className="process_button_single text-sm px-3 py-1 border-[#00D632] border-2 rounded font-semibold hover:bg-[#00D632] hover:text-white disabled:opacity-30 disabled:cursor-not-allowed">Process</button>
                                                </td>
                                            </tr>
                                        ))}
                                        
                                        
                                    </tbody>
                                </table>

                            </div>

                            <>
                            
                                <p className='text-center w-full mt-5'>
                                    Total <b>{orderList.length ?? 0}</b> records found
                                </p>

                            </>

                        </div>
                    </div>
                </div>
            </div>

            {/* Process Dialog */}
            {(showProcessDialog === true) &&
                <div>
                    <Popup content={
                        <form className="p-5 font-medium">
                            <div className="flex justify-between">
                                <h3 className="text-lg text-black font-semibold">Process Settlement</h3>
                                <CloseBtn className="cursor-pointer" onClick={closeProcessBox} />
                            </div>

                            <div className='max-w-lg mt-6 pr-1 whitespace-break-spaces'>
                                <table className="custom-details-table w-full mt-0 mb-2">
                                    <tbody>
                                        <tr>
                                            <td className="font-semibold text-base">Order Amount (A)</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{process.env.REACT_APP_CURRENCY_SYMBOL} {number_format(processData.order_amount ?? 0,2)}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Settlement Fee (B)</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{process.env.REACT_APP_CURRENCY_SYMBOL} {number_format(processData.settlement_fee ?? 0,2)}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Net Price (A-B)</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{process.env.REACT_APP_CURRENCY_SYMBOL} {number_format(processData.settled_amount ?? 0, 2)}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Trade Price</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{process.env.REACT_APP_CURRENCY_SYMBOL} {number_format(processData.trade_price ?? 0,2)}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Settlement Type</td>
                                            <td className="px-5 text-base">
                                                {/* {(processData.trade_price <= 0 || processData.trade_price === "-") ?
                                                    <>
                                                        <input type="hidden" value="net_price" name="settled_amount_opt" />
                                                        {process.env.REACT_APP_CURRENCY_SYMBOL}<span> {number_format(processData.settled_amount ?? 0, 2)}</span>
                                                    </>
                                                    : */}
                                                    <>
                                                        <span className="mr-3 cursor-pointer border b-2 border-blue-500 py-1 px-2 rounded">
                                                            <input type="radio" value="trade_price" onChange={changeSettledAmountOption} defaultChecked={companyProfile?.settlement_type === "trade_price"} className="-mt-1" name="settled_amount_opt" id="settled_amount_trade_price" /> 
                                                            <label className="ml-1 mt-1 cursor-pointer" htmlFor="settled_amount_trade_price">Trade Price</label>
                                                        </span>
                                                        
                                                        <span className="cursor-pointer border border-blue-400 py-1 px-2 rounded">
                                                            <input type="radio" value="net_price" onChange={changeSettledAmountOption} defaultChecked={companyProfile?.settlement_type === "net_price"} className="-mt-1" name="settled_amount_opt" id="settled_amount_net_price" /> 
                                                            <label className="ml-1 mt-1 cursor-pointer" htmlFor="settled_amount_net_price">Net Price</label>
                                                        </span>
                                                    </>
                                                {/* } */}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Transaction Count</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{processData.count}</div>
                                            </td>
                                        </tr>

                                        {(processData.trade_price > 0) ? 
                                            <tr>
                                                <td className="font-semibold text-base">Settled Amount</td>
                                                <td className="px-5 text-base">
                                                    {/* <div className='flex items-center' id="settled_amount_display_net_price" style={{display: "none"}}>
                                                        {process.env.REACT_APP_CURRENCY_SYMBOL} 
                                                        <span>{number_format(processData.settled_amount ?? 0, 2)}</span>
                                                    </div>
                                                    <div className='flex items-center' id="settled_amount_display_trade_price">
                                                        {process.env.REACT_APP_CURRENCY_SYMBOL} <span>{number_format(processData.trade_price ?? 0, 2)}</span>
                                                    </div> */}

                                                    <div
                                                    className="flex items-center"
                                                    id="settled_amount_display_net_price"
                                                    style={{
                                                        display:
                                                        companyProfile?.settlement_type === "net_price" ? "flex" : "none",
                                                    }}
                                                    >
                                                        {process.env.REACT_APP_CURRENCY_SYMBOL}
                                                        <span>{number_format(processData.settled_amount ?? 0, 2)}</span>
                                                    </div>

                                                    <div
                                                    className="flex items-center"
                                                    id="settled_amount_display_trade_price"
                                                    style={{
                                                        display:
                                                        companyProfile?.settlement_type === "trade_price" ? "flex" : "none",
                                                    }}
                                                    >
                                                        {process.env.REACT_APP_CURRENCY_SYMBOL}
                                                        <span>{number_format(processData.trade_price ?? 0, 2)}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            :
                                            <tr>
                                                <td className="font-semibold text-base">Settled Amount</td>
                                                <td className="px-5 text-base">
                                                    <div className='flex items-center' id="settled_amount_display_net_price">
                                                        {process.env.REACT_APP_CURRENCY_SYMBOL} <span>{number_format(processData.settled_amount ?? 0, 2)}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        }

                                        <tr>
                                            <td className="font-semibold text-base">Remarks</td>
                                            <td className="p-2 text-base" style={{backgroundColor: "white"}}>
                                                <textarea className="w-full h-[100px] resize-none rounded-md border-gray-300 text-sm hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                                                onChange={(e) => setProcessData({ 
                                                    ...processData, 
                                                    remarks: e.target.value 
                                                })}
                                                name="remarks" id="remarks" maxLength={100}
                                                placeholder="Enter Remarks (optional)"></textarea>
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>

                                <button type="button" onClick={processConfirm} className="mt-5 mb-2 w-full py-1.5 text-md font-semibold border-[#00D632] border-2 rounded bg-[#00D632] text-white hover:bg-white hover:text-[#00D632]">
                                    Confirm Process
                                </button>
                        
                            </div>

                        </form>}
                    />
                </div>
            }
            {/* Process Dialog End */}

            {/* Right Side */}
            <div id="filter-div" className="custom-container-right float-right w-1/5 pl-2 pb-10 pt-4 pr-1 justify-center custom-scroll-auto mb-20 no-need-without-shadow">
                <div className="relative">
                    <h6 className="text-lg px-3 font-base pb-2 pl-2" style={{ boxShadow: "0 3px 0 0 rgb(0 0 0 / 1%)" }}>Filter Settlement</h6>

                    <div className="box-full w-full  text-justify py-2 pl-2 pr-1">
                        <div className="w-full float-left pt-2">
                            <select onChange={setDatePicker} id="date-range-data" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="custom">
                                <option value="all">Single Date</option>
                                <option value="custom">Date Range</option>
                            </select>
                            <DatePickerV2 />
                            <DatePickerRange />
                        </div>
                    </div>
                    
                    <div className="box-full block w-full h-full text-justify pl-2">
                        <div className="w-full float-left pb-1 pt-5">
                            <select id="service_type" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">Service Type</option>
                                <option value="shop">Shop</option>
                                <option value="voucher">Voucher</option>
                            </select>
                        </div>
                    </div>

                    <div className="box-full flex w-[97%] h-full text-justify py-0.5 px-0.5 ml-2 mt-5 mb-6 bg-[#F5F5F5] rounded">
                        <div className="w-full h-full float-left">
                            <input type="text" id="search-by-transaction-id" name="search-by-transaction-id" autoComplete='off' className="custom-search-fields w-full text-base border-0 rounded placeholder:text-ash" placeholder='Search by Transaction ID' />

                        </div>
                    </div>


                    <button onClick={filter} className="custom-btn w-[97%] flow-root float-left ml-2 mt-2">Filter</button>
                    {isFilter && <button onClick={resetFilterData} className="custom-btn ml-2 mt-3 flow-root w-[97%] float-left bg-black text-white border-black" style={{ color: "#FFF" }}>Reset Filter</button>}

                </div>
            </div>
        </div>
    );
    
};

export default SettlementProcess;